/* unplugin-vue-components disabled */import { render } from "./IosPayAgreement.vue?vue&type=template&id=15c6d0b8&scoped=true"
import script from "./IosPayAgreement.vue?vue&type=script&lang=js"
export * from "./IosPayAgreement.vue?vue&type=script&lang=js"

import "./IosPayAgreement.vue?vue&type=style&index=0&id=15c6d0b8&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c6d0b8"]])

export default __exports__